import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { memo, useMemo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import ChargeWaiverTablePanel from "../Table/ChargeWaiverTablePanel";
import ChargeWaiverEditPanel from "./ChargeWaiverEditPanel";
import ChargeWaiverReasonPanel from "./ChargeWaiverReasonPanel";

const ChargeWaiverRightPanel = () => {
    const [chargeWaiverState] = useChargeWaiverTracked();
    const { isShowEditPanel, isShowBulkEditPanel, isShowRejectPanel, isShowReversePanel } = chargeWaiverState;

    const memoChargeWaiverTable = useMemo(() => {
        return <ChargeWaiverTablePanel />
    }, [])
    const memoChargeWaiverEditPanel = useMemo(() => {
        return <ChargeWaiverEditPanel />
    }, [])
    const memoChargeWaiverReasonPanel = useMemo(() => {
        return <ChargeWaiverReasonPanel />
    }, [])

    return <>
        <div className={`main-comp-wrapper${(isShowEditPanel || isShowBulkEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>

            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowEditPanel || isShowBulkEditPanel || (isShowRejectPanel || isShowReversePanel) ? "75%" : "100%"}
                rightSectionWidth={isShowEditPanel || isShowBulkEditPanel || (isShowRejectPanel || isShowReversePanel) ? "25%" : "0%"}
                leftChildren={memoChargeWaiverTable}
                rightChildren={(isShowRejectPanel || isShowReversePanel) ? memoChargeWaiverReasonPanel : memoChargeWaiverEditPanel}
            />
        </div>
    </>
}

export default memo(ChargeWaiverRightPanel);